import { render, staticRenderFns } from "./ScorePinAvg.vue?vue&type=template&id=0e25c6f4&scoped=true&"
import script from "./ScorePinAvg.vue?vue&type=script&lang=ts&"
export * from "./ScorePinAvg.vue?vue&type=script&lang=ts&"
import style0 from "./ScorePinAvg.vue?vue&type=style&index=0&id=0e25c6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25c6f4",
  null
  
)

export default component.exports